<a *ngIf="hasAccess" (click)="onClick()" [routerLink]='url'>
	<ng-container *ngTemplateOutlet="contentTpl"></ng-container> 
</a>
<span *ngIf="!hasAccess">
	<ng-container *ngTemplateOutlet="contentTpl"></ng-container> 
</span>
<ng-template #contentTpl><ng-content></ng-content></ng-template>
